var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m480-406.667-192 192q-15.334 15.334-36.667 15.334-21.333 0-36.666-15.334-15.334-15.333-15.334-36.666T214.667-288l192-192-192-192q-15.334-15.334-15.334-36.667 0-21.333 15.334-36.666 15.333-15.334 36.666-15.334T288-745.333l192 192 192-192q15.334-15.334 36.667-15.334 21.333 0 36.666 15.334 15.334 15.333 15.334 36.666T745.333-672l-192 192 192 192q15.334 15.334 15.334 36.667 0 21.333-15.334 36.666-15.333 15.334-36.666 15.334T672-214.667l-192-192Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomClose);
export default __webpack_public_path__ + "static/media/custom-close.b40212fa177075af06e160b09c739bb1.svg";
export { ForwardRef as ReactComponent };